import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconFilter } from '@medifind/icons';
import { FilterModal } from '../filters';
import { SortBy } from './SortBy';
import { TotalResults } from './TotalResults';
import styles from './SortingHeader.module.scss';

const SortingHeader = ({
  classes = {},
  style = {},
  onSortByChange,
  sortValue,
  totalResults,
  sortItems,
  foundText = 'Found',
  isTop,
  filterList,
  activeFiltersCount,
  parentContainer,
  clearFilters,
  hideTotalResults,
  hideFilterButtonAt = 'md',
  showActiveFilterCount = true,
}) => {
  return (
    <div
      className={classNames(classes.sortContainer, styles['sort-container'], {
        [styles['sort-container--is-top']]: isTop,
      })}
      style={style.sortContainer}
    >
      {!hideTotalResults && <TotalResults totalResults={totalResults} foundText={foundText} />}
      <div className={classNames(styles['sort-container--buttons'])}>
        {filterList && (
          <FilterModal
            classes={{
              modalContent: classes.modalContent,
            }}
            style={style.modalContent}
            title="Filter your search"
            clearFilters={clearFilters}
            filterButton
            filterButtonLabel={<>Filter{showActiveFilterCount && <span style={{ fontSize: '12px' }}> ({activeFiltersCount})</span>}</>}
            iconBefore={<IconFilter color="#242a45" />}
            resultsText={<TotalResults totalResults={totalResults} foundText={foundText} />}
            parentContainer={parentContainer}
            hideFilterButtonAt={hideFilterButtonAt}
          >
            {filterList}
          </FilterModal>
        )}
        {sortItems && <SortBy onSortByChange={onSortByChange} sortValue={sortValue} sortItems={sortItems} />}
      </div>
    </div>
  );
};

SortingHeader.propTypes = {
  classes: PropTypes.shape({
    filters: PropTypes.string,
    filterWrapper: PropTypes.string,
    filterHeader: PropTypes.string,
    sortContainer: PropTypes.string,
    modalFiltersWrapper: PropTypes.string,
    modalFilterWrapper: PropTypes.string,
    moreFiltersButton: PropTypes.string,
    filterSortContainer: PropTypes.string,
    modalContent: PropTypes.string,
  }),
  onSortByChange: PropTypes.func,
  sortValue: PropTypes.any,
  sortItems: PropTypes.any,
  totalResults: PropTypes.number,
  foundText: PropTypes.string,
  isTop: PropTypes.bool,
  filterList: PropTypes.node,
  activeFiltersCount: PropTypes.number,
  parentContainer: PropTypes.any,
  clearFilters: PropTypes.func,
  hideFilterButtonAt: PropTypes.string,
  hideTotalResults: PropTypes.bool,
  showActiveFilterCount: PropTypes.bool,
};

export { SortingHeader as default, SortingHeader };
